exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CanvasOutput_input_3eB_L{display:block;width:100%;padding:10px;margin:10px;color:red;font-weight:900}", ""]);

// exports
exports.locals = {
	"input": "CanvasOutput_input_3eB_L"
};